import { useState, useEffect } from 'react';
import { isPrivateBrowsing } from '@/lib/db';
import styles from '@/styles/components/PrivateModeWarning.module.css';

export function PrivateModeWarning() {
  const [isPrivate, setIsPrivate] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    isPrivateBrowsing().then(setIsPrivate).catch(() => {});
  }, []);

  if (!isPrivate || dismissed) return null;

  return (
    <div className={styles.banner} role="alert">
      <span className={styles.text}>
        ⚠ Private/incognito browsing detected. Your data may not be saved.
      </span>
      <button
        className={styles.dismiss}
        onClick={() => setDismissed(true)}
        aria-label="Dismiss warning"
      >
        ✕
      </button>
    </div>
  );
}
